const ACTIONS = "data-cms-preview-actions";

// This function is serialized into the sandbox, so it must not close over module state.
export function installEditorPreviewGuard() {
  const editing = () => document.documentElement.getAttribute("data-cms-editor-mode") !== "interact";
  const guard = (event: Event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!editing() || !target || target.closest(".tox, #inline-html-hugerte-toolbar")) return;
    if (event.type === "submit" || target.closest("a, area, button, input[type=submit], input[type=image], [role=button]")) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  };
  document.addEventListener("click", guard, true);
  document.addEventListener("auxclick", guard, true);
  document.addEventListener("submit", guard, true);
  document.addEventListener("keydown", event => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest("[contenteditable=true], [contenteditable=plaintext-only]")) return;
    guard(event);
  }, true);
}

export function neutralizePreviewActions(doc: Document) {
  doc.documentElement.setAttribute("data-cms-editor-mode", "edit");
  doc.querySelectorAll("*").forEach(element => {
    const actions: Record<string, string> = {};
    for (const attribute of Array.from(element.attributes)) {
      const name = attribute.name.toLowerCase();
      if (/^on/.test(name) || (name === "href" && element.matches("a, area"))
        || (name === "action" && element.tagName === "FORM") || name === "formaction") {
        actions[name] = attribute.value;
        element.removeAttribute(attribute.name);
      }
    }
    if (Object.keys(actions).length) {
      // Preserve metadata already supplied by the renderer when applying the editor fallback.
      const previous = element.getAttribute(ACTIONS);
      let original: Record<string, string> = {};
      if (previous) {
        try { original = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(previous), char => char.charCodeAt(0)))); }
        catch { /* Ignore malformed preview metadata in authored HTML. */ }
      }
      const bytes = new TextEncoder().encode(JSON.stringify({ ...original, ...actions }));
      element.setAttribute(ACTIONS, btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join("")));
    }
  });
}

export function editorPreviewDocument(html: string): string {
  if (!html) return html;
  const doc = new DOMParser().parseFromString(html, "text/html");
  neutralizePreviewActions(doc);
  if (!doc.querySelector("script[data-cms-editor-guard]")) {
    const guard = doc.createElement("script"); guard.setAttribute("data-cms-editor-guard", "");
    guard.textContent = `(${installEditorPreviewGuard.toString()})();`;
    doc.head.prepend(guard);
  }
  return "<!doctype html>" + doc.documentElement.outerHTML;
}
